<template>
  <PropertyCheckList v-if="showUtilities" :items="items" :limit="items.length" />
  <Text v-else variant="body-medium">Not included in rent</Text>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';

import { includedUtilitiesMap, includedUtilityIconsMap } from '../../model/included-utilities';
import { PropertyDto } from '../../model/property';
import PropertyCheckList, { CheckListItem } from './property-check-list.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

// false is an explicit "not included" from the owner's ✓/✗ form; null means never answered and stays hidden.
// Included utilities come first, then the crossed-out ones
const items = computed<CheckListItem[]>(() =>
  Array.from(includedUtilitiesMap)
    .map(([key, label]) => ({
      label,
      value: props.property?.includedUtilities?.[key],
      icon: includedUtilityIconsMap[key],
    }))
    .filter((item) => item.value !== null && item.value !== undefined)
    .sort((a, b) => Number(!a.value) - Number(!b.value)),
);

// "No utilities included" in the form overrides whatever the per-utility marks say
const showUtilities = computed(
  () => Boolean(props.property?.includedUtilities?.isUtilitiesIncludedInRent) && items.value.length > 0,
);
</script>
